<mat-card appearance="outlined" class="bandwidth-card">
  <div class="header">
    <h2>Bandwidth</h2>
  </div>
  <div class="row">
    <div class="spinner">
      <mat-progress-spinner
        diameter="126"
        class="bandwidth-circle"
        mode="determinate"
        [value]="bandwidthPercent()"
      ></mat-progress-spinner>
      <span class="spinner-text">{{ bandwidthPercent() }}%</span>
      <div class="spinner-background"></div>
    </div>

    <div class="texts">
      <span>Current month</span>
      <span
        ><span class="bold">{{ currentUsage() | bytesToSize }}</span> /
        {{ bandwidthLimit() | bytesToSize }}</span
      >
    </div>
  </div>
  <p class="hint">The limit resets on every 1st of the month.</p>
</mat-card>
